import { RoleAuthTarget } from '@boma/client-shared';

export function hasRole(role: RoleAuthTarget, roles: number) {
  return (
    // tslint:disable-next-line:no-bitwise
    (roles & role) === role.valueOf()
  );
}
